export const en = {
  translation: {
    environment_header: "This is a {{environment}} environment",
    footer: "© {{year}} TailorMed. All rights reserved",
    main_title: "Free Drug Orders",
    search_placeholder: "Search Patient by MRN, Name or ID",
    download_report: "Download Report",
    contact_support: "Contact Support",
    login_email_support: "E-mail support",
    filters: "Filters",
    filters_selected: "{{num}} selected",
    date_range_field: "Date Range Field",
    order_admin_field: "Order + Admin Date",
    order_field: "Order Date",
    admin_field: "Admin Date",
    date_range: "Date Range",
    order_date: "Order Date",
    admin_date: "Admin Date",
    estimated_delivery_date: "Estimated Delivery Date",
    received_date: "Received Date",
    bill_voided: "Bill Voided",
    bill_voided_date: "Bill Voided Date",
    order_view: "Order View",
    new_drug_order: "Add Patient",
    pharmacy: "Pharmacy",
    all: "All",
    all_times: "All Times",
    this_week: "This Week",
    this_month: "This Month",
    last_week: "Last Week",
    last_month: "Last Month",
    next_week: "Next Week",
    next_month: "Next Month",
    this_year: "This Year",
    next_12_months: "Next 12 Months",
    next_calendar_year: "Next Calendar Year",
    previous_year: "Previous Year",
    all_cycles: "All Cycles",
    up: "Up",
    show_inactive_orders: "Show Inactive Orders",
    ok: "OK",
    deceased: "Deceased",
    last_updated: "Last Updated",
    last_updated_by: " by {{updatedBy}}",
    preview: "Preview",
    apply: "Apply",
    reset: "Reset",
    delete: "Delete",
    open: "Open",
    send: "Send",
    upload: "Upload",
    clear_all: "Clear All",
    clear: "Clear",
    today: "Today",
    week: "Week",
    month: "Month",
    edit: "Edit",
    submit: "Submit",
    save: "Save",
    cancel: "Cancel",
    overdue: "Overdue",
    sure_to_cancel: "Are you sure?",
    back: "Back",
    inactive: "Inactive",
    column_selector: "Column Selector",
    add_note: "Add Note",
    add_attachment: "Add Attachment",
    search_results: "Search results",
    recent_patients: "Recent Patients",
    yes_sure: "Yes, I'm Sure",
    ok_text: "Yes, I'm Sure",
    keep_note: "Keep note",
    delete_note: "Delete note",
    fn_link: "FN Link",
    attachments_disabled: "You don’t have permissions to download this file",
    filter_by: "Filter By",
    unassigned: "Unassigned",
    select_all: "Select All",
    type_to_search: "Type to search",
    infusion: "Infusion",
    subcutaneous: "Subcutaneous",
    oral_and_others: "Oral and Others",
    header_menu: {
      sign_out: "Sign Out",
      email_configuraion: {
        title: "Manage Email Notification",
        weekly: "Weekly email",
        daily: "Daily email",
        program_open: "Open funds"
      }
    },
    header_searchbar: {
      show_all_results: "Show {{totalRecordsNumber}} results",
      active_column: "Status",
      active: "Active",
      in_active: "Inactive",
      show_more: "Show More",
      autocomplete_search_results_list: {
        name_id: "No patients found",
        dob: "For results, enter the patient’s full DOB.",
        phone_number: "For results, enter the patient’s full phone number.",
        social_security_number: "For results, enter the patient’s full SSN.",
        no_results: "No Results Found"
      },
      searched_patients_assignees: "Assignee",
      searched_patients_drug: "Drug",
      searched_patients_name: "Patient",
      searched_patients_name_id: "Name, ID",
      recent_patients_name: "Recently Viewed",
      option_type_list: {
        name_id: "Name / ID",
        dob: "Date of Birth",
        phone: "Phone",
        ssn: "SSN"
      },
      placeholder: {
        name_id: "Search patients by Name, ID or MRN",
        dob: "MM/DD/YYYY",
        phone_number: "(000) 000-0000",
        social_security_number: "123-12-1234"
      },
      search_results_title: {
        dob: "DOB",
        phone_number: "Phone",
        social_security_number: "SSN",
        recently_viewed: "Recently Viewed",
        status: "Status"
      },
      record_mrn: "MRN-{{mrnRecord}}",
      record_phone: "Phone: {{mrnRecord}}"
    },
    support: {
      title: "Contact Support: Patient ({{ site }} {{ id }}) ",
      disclaimer: "Please make sure not to share Protected Health Information (ePHI) in the subject",
      description: "Description",
      subject: "Subject",
      description_required: "Description is required",
      subject_required: "Subject is required"
    },
    action_modal: {
      ordered: {
        title: "Patient ({{ site }}-{{ id }}) Drug Order",
        order_date_label: "Actual Order Date"
      },
      no_cycles: {
        title: "Patient ({{ site }}-{{ id }}) No Orders Remaining",
        select_one: "Select One Of The Following",
        add_cycle: "Add Order",
        set_inactive: "Set Inactive"
      }
    },
    filter: {
      status: {
        label: "Status",
        done: "Done",
        not_done: "Not Done"
      },
      assignee: {
        all_assignees: "All Assignees",
        no_assignee: "Unassigned"
      }
    },
    form: {
      validation: {
        numbers_only: "Only numbers allowed",
        integers_only: "Only Integer allowed",
        range: "'{{name}}' must be between {{min}} and {{max}}",
        max_not_exceed: "'{{name}}' must not exceed {{maxNumberOfDigits}} characters."
      },
      physician: {
        label: "Physician",
        placeholder: "-",
        error_required: "Please input physician",
        popover: {
          npi: "NPI",
          dea: "DEA",
          stateLisence: "State License",
          phone: "Phone",
          fax: "Fax",
          address: "Address",
          email: "Email"
        }
      },
      refills: {
        label: "Refills",
        placeholder: "Refills",
        error_required: "Please input Refills",
        zero_refills: "No refills"
      },
      lot_number_received: {
        label: "Lot Number Received",
        placeholder: "Lot Number Received"
      },
      lot_number_dispensed: {
        label: "Lot Number Dispensed",
        placeholder: "Lot Number Dispensed"
      },
      unitCost: {
        label: "Unit Price",
        placeholder: "Unit Price"
      },
      totalAmount: {
        label: "Total Price",
        placeholder: "Total Price"
      },
      order_type: {
        label: "Order Type",
        placeholder: "Order Type",
        free_text: "Free",
        replecement_text: "Replacement"
      },
      order_date: {
        label: "Order Date",
        placeholder: "Order Date",
        error_required: "Please input the order date"
      },
      admin_date: {
        label: "Admin Date",
        placeholder: "Admin Date",
        error_required: "Please input the admin date"
      },
      bill_voided: {
        label: "Bill Voided",
        placeholder: "Bill Voided",
        placeholder_date: "Bill Voided Date",
        no_text: "No",
        yes_text: "Yes",
        date_error_required: "Please input the bill voided date",
        checkbox_error_required: "Please mark the bill voided",
        select_error_required: "Please select the bill voided"
      },
      status: {
        label: "Status",
        placeholder: "Status"
      },
      quantity: {
        label: "Quantity",
        placeholder: "Quantity",
        error_required: "Please input the quantity"
      },
      account_number: {
        label: "Account Number",
        placeholder: "Account Number"
      },
      dosage: {
        label: "Dosage",
        placeholder: "Drug dosage",
        error_required: "Please input the drug dosage",
        error_validation: "Must be a valid number. May contain a '-' separator",
        popover:
          "For drugs with more than one active ingredient, enter each ingredient’s dose separated by a dash. For example, 24-26 or 1.5-2.5"
      },
      unit: {
        label: "Dosage Unit",
        placeholder: "Unit",
        error_required: "Please input the drug unit"
      },
      cycle: {
        label: "Order",
        placeholder: "Order",
        error_required: "Please input order",
        per_patient: "Per Patient",
        per_cycle: "Per Order",
        cycle_number: "Order {{cycleNum}}",
        current_indicator: "(Current)",
        current_cycle_number: "Current {{cycleNumber}}"
      },
      from_cycle: {
        label: "Apply from order",
        error_required: "Please input apply from order"
      },
      days_before: {
        label: "Days before/after admin",
        before: "Before",
        after: "After",
        error_required: "Please input days before/after administration"
      },
      days_between: {
        label: "Days between orders",
        error_required: "Please input order frequency"
      },
      estimated_date: {
        label: "Estimated Delivery",
        placeholder: "Estimated Delivery Date",
        error_required: "Please input the estimated delivery date"
      },
      arrive_date: {
        label: "Received Date",
        placeholder: "Received Date",
        error_required: "Please input the Received Date"
      },
      note: {
        label: "Note",
        placeholder: "Notes",
        error_required: "Please enter note",
        popover: "Enter note"
      },
      task: {
        label: "Task",
        placeholder: "Task text",
        error_required: "Please enter task",
        popover: "Enter task"
      },
      due_date: {
        label: "Due Date",
        placeholder: "Due Date",
        error_required: "Please input the task's due date"
      },
      assignee: {
        id: "patient_assignee",
        label: "Pharmacy Assignee",
        placeholder: "Select Assignee",
        error_required: "Please choose assignee",
        clear_assignee: "No assignee"
      },
      facility: {
        id: "patient_facility",
        label: "Pharmacy Facility",
        placeholder: "Select facility"
      },
      carrier: {
        label: "Carrier",
        placeholder: "Carrier",
        error_required: "Choose a carrier",
        fedex: "FedEx",
        ups: "UPS",
        usps: "USPS",
        dhl: "DHL",
        amazon: "Amazon"
      },
      rx_instructions: {
        label: "Rx instructions",
        empty_placeholder: "-",
        placeholder: "Enter instructions",
        error_required: "Rx instructions requaired"
      },
      rx_number: {
        label: "Rx number",
        empty_placeholder: "-",
        placeholder: "Enter number",
        error_required: "Rx number requaired"
      },
      tracking_number: {
        label: "Tracking No.",
        placeholder: "Tracking Number",
        error_required: "Please input one tracking number",
        error_pattern: "Tracking Number must contain only numbers and letters"
      }
    },
    orders_table: {
      date_range_placeholder: "Date range",
      date_range_week: "Week",
      date_range_month: "Month",
      date_range_year: "Year",
      order_type_free: "Free Drug",
      order_type_replacement: "Replacement Drug"
    },
    orders_calender: {
      order_table_changed: "Order date changed",
      order_date_changed: "The order date was changed from {{formDate}} to {{toDate}}"
    },
    statuses: {
      titles: {
        order_required: "Order Required",
        in_transit: "In Transit",
        in_pharmacy: "In Pharmacy",
        drug_dispensed: "Drug Dispensed",
        drug_billed: "Drug Billed"
      },
      actions: {
        ordered: "Mark as Ordered",
        arrived: "Mark as Arrived",
        dispensed: "Mark as Dispensed",
        done: "Mark as Done"
      }
    },
    main_view: {
      list: "List",
      calendar: "Calendar",
      save_as_new_list: "Save As New List",
      saved_list: "Saved Lists",
      error_messages: {
        failed_to_get_pharmacy_patient: "Failed to get pharmacy patient"
      }
    },
    new_patient: {
      title: "Add New Patient",
      demographics: "Demographics",
      patient_label: "PATIENT NAME",
      first_name_placeholder: "First name",
      first_name_required: "Please input first name",
      middle_name_placeholder: "Middle name",
      last_name_placeholder: "Last name",
      last_name_required: "Please input last name",
      date_of_birth_label: "DATE OF BIRTH",
      date_of_birth_required: "Please input date of birth",
      state_required: "Please input state",
      state_placeholder: "State",
      mrn_label: "MRN",
      mrn_placeholder: "MRN",
      mrn_required: "Please input MRN",
      physician_label: "PHYSICIAN",
      program_label: "PROGRAM",
      assistance_program_placeholder: "Assistance program",
      assistance_program_required: "Please input the assistance program",
      drug_name_placeholder: "Drug name",
      drug_name_required: "Please input the drug name",
      unit_placeholder: "Select unit",
      cycles_placeholder: "Number of orders",
      cycles_required: "Please input the number of orders",
      order_frequency_placeholder: "Order frequency",
      order_frequency_required: "Please input the order frequency",
      current_cycle_placeholder: "Current order",
      current_cycle_required: "Please input the current order",
      next_admin_date_placeholder: "Next admin date",
      next_admin_date_required: "Please input the next admin date",
      only_digits_rule: "Only digits are allowed",
      program_selection: "Program Selection",
      type_to_search: "Type to search",
      current_cycle_value_error_msg: "Current order cannot be greater than the total number of orders",
      number_of_cycles_greater_thant_zero: "Number of orders must be greater than 0",
      current_cycle_greater_thant_zero: "Current order must be greater than 0",
      assistance_program: {
        required_message: "Please input assistance program"
      },
      rxnormDrug: {
        required_message: "Please input drug"
      },
      dose_form: {
        placeholder: "Select dose form"
      },
      strength: {
        placeholder: "Select strength"
      },
      dosage: {
        placeholder: "Dosage amount",
        validation_error: "Must be a valid number. May contain a '-' separator",
        required_message: "Please input dosage"
      },
      dosage_unit: {
        required_message: "Please input dosage unit"
      },
      num_of_cycles: {
        addon_before: "No.",
        placeholder: "Number of fills/orders",
        required_message: "Please input number of orders",
        max_cycles_message: "Maximum number of orders is"
      },
      days_supply: {
        placeholder: "Days supply",
        tooltip: 'Can be also called "Days Supply" = how how many days each fill is intended to last.',
        required_message: "Please input days supply"
      },
      units_per_day: {
        label: "Units per day",
        placeholder: "Units per day ",
        required_message: "Please input units per day"
      },
      start_date: {
        required_message: "Start date is required"
      },
      nextAdminDate: { placeholder: "Next admin date", required_message: "Please input next admin date" },
      physician: { placeholder: "Choose physician" },
      current_cycle: {
        required_message: "Please input current order"
      }
    },
    patient: {
      tabs: {
        current_cycle: "Order Details",
        cycles: "All Orders",
        cycles_editor: "Orders Editor",
        notes: "Notes",
        attachments: "Attachments",
        tasks: "Tasks",
        tracking: "Tracking"
      },
      set_inactive: "Set Inactive",
      clone: "Clone",
      activate: "Activate",
      edit_confirm_title: "Changes Not Saved",
      edit_confirm_content: "Are you sure want to leave without saving?",
      are_you_sure_clone_title: "Clone patient",
      are_you_sure_clone_content: "Are you sure you want to clone the patient",
      recipient: {
        recipient: "Recipient",
        recipient_placeholder: "-",
        recipient_selector_placeholder: "Select recipient",
        financialNavigationTeam: "Financial Navigation Team",
        physician: "Physician",
        patient: "Patient"
      },
      order: {
        time_status: {
          past: "Past",
          current: "Current",
          future: "Future"
        },
        switch_order_dropdown_label: "Switch order",
        label_format: "Order {{orderNumber}}/{{totalOrders}} ({{adminDate}})"
      },
      general: {
        assistance_program_name: "Assistance Program Name",
        order_info: "Order Info",
        medication_order_info: "Medication Order Info",
        progarm_info: "Program Info",
        application_info: "Application Info",
        program_website_label: "Program Website",
        program_website_link: "Website",
        program_contact_label: "Program Contact",
        program_phone_for_reffils_label: "Refill Phone no.",
        approval_date: "Approval Date",
        expiration_date: "Expiration Date",
        program_address_label: "Program Address",
        treatment_cycles: "Treatment Orders",
        assignee: "Assignee",
        assignee_placeholder: "select Assignee",
        application_id: "Application ID",
        cycle_notes: "Order Notes",
        bill_voided: "Bill Voided",
        order_frequency: "Order Frequency",
        drug_name: "Drug Name",
        dose_form_category: "Dose Form Category",
        generic_name: "Generic Name",
        drug_manufacturer: "Drug Manufacturer",
        brand_name: "Brand Name/s",
        hcpcs: "Jcode/HCPCS",
        physician_selector_placeholder: "Select physician",
        dosage: "Dosage",
        order_type: "Order type",
        is_overdue: "Order is overdue",
        phone: "Phone",
        email: "Email",
        address: "Address",
        fax: "Fax",
        tax_id: "Tax ID",
        ssn: "SSN",
        phone1: "Phone 1",
        phone2: "Phone 2"
      },
      cycles: {
        estimated_delivery_title: "Estimated Delivery",
        arrive_date_title: "Received Date",
        change_cycle_modal_title: "Change current order",
        change_cycle_modal_content: "Are you sure you want to change the current order?",
        cycle_title: "Order #",
        refills_title: "Refills",
        lot_number_dispensed: "Lot Number Dispensed",
        lot_number_received: "Lot Number Received",
        account_number: "Account Number",
        type_title: "Type",
        order_title: "Order date",
        admin_title: "Admin date",
        bill_voided_date: "Bill Voided Date",
        dosage_title: "Dosage",
        drug_title: "Drug Name",
        unit_title: "Dosage Unit",
        quantity_title: "Quantity",
        quantity_title_abbreviation: "Qty",
        unit_cost_title: "Unit Price",
        total_amount_title: "Total Price",
        bill_voided_title: "Bill Voided",
        status_title: "Status",
        add_cycle_button: "Add Order",
        set_all_placeholder: "Set all orders as",
        set_all_free: "Free",
        admin_date: "Admin Date",
        set_all_replacement: "Replacement",
        edit_all_cycles: "Edit All Orders",
        confirm_delete_title: "Delete Order",
        confirm_delete_content: "Are you sure you want to delete this order?",
        confirm_delete_content_with_notes_attach:
          "This order has associated notes or attachments. Deleting it will permanently remove all related data. Continue?",
        empty_text_title: "Nothing to show here right now.",
        empty_text_description: "You can change the date filter to see past or upcoming administration dates."
      },
      notes: {
        col_title_date: "Date",
        col_title_user: "Added by",
        col_title_cycle: "Order #",
        col_title_admin_date: "Admin Date",
        col_title_note: "Note",
        add_button: "Add Note",
        confirm_delete_title: "Confirm Delete",
        confirm_delete_content: "Are you sure that you want to delete this note?",
        user_error: "Only a user can delete his own notes",
        last_updated_by: "Last Updated By",
        actions: "Actions",
        save_note: "Save Note",
        edit_note_placeholder: "Edit your note...",
        character_limit_exceeded: "Character limit exceeded (max 1000)",
        no_notes_yet: "No notes yet",
        start_by_typing_in_the_box_above: "Add a note using the button above.",
        unsaved_changes_title: "Unsaved Changes",
        unsaved_changes_message:
          "You have unsaved changes in your note. Leaving the note will discard any unsaved changes. Are you sure you want to proceed?",
        see_more: "See More",
        see_less: "See Less"
      },
      attachments: {
        col_title_date: "Date",
        col_title_user: "Added by",
        col_title_cycle: "Order #",
        col_title_attachment: "Attachment",
        col_title_admin_date: "Admin Date",
        add_button: "Add Attachments",
        confirm_delete_title: "Delete Attachment",
        confirm_delete_content: "Are you sure you want to delete the attachment?",
        confirm_download_title: "Download Attachment",
        confirm_download_content: "Are you sure you want to download the attachment?",
        max_file_size: "Up to 15MB per file",
        browse: "Browse",
        file_size_exceeds: "File size extends {{maxFileSize}} MB max: {{fileSize}} MB"
      },
      tasks: {
        col_title_date: "Created At",
        col_title_due_date: "Due Date",
        col_title_cycle: "Order",
        col_title_assignee: "Assignee",
        col_title_task: "Task",
        col_title_status: "Done",
        confirm_delete_title: "Delete task",
        confirm_delete_content: "Are you sure you want to remove the task?",
        text_error_required: "Please input a task",
        add_button: "Add Task"
      },
      tracking: {
        status: {
          proccessing: "Processing",
          transit: "In Transit",
          delivered: "Delivered"
        },
        add_button: "Track Package",
        success: "Success"
      }
    },
    calculator: {
      title: "Drug Price Calculator",
      loading_drug_information: "Loading drug information",
      drugNameTitle: "Drug Name & Unit Type",
      manufacturerTitle: "Manufacturer",
      manufacturerImport: "Input Manufacturer Name",
      unitNumberTitle: "Number of Units",
      unitSizeTitle: "Quantity / Unit size",
      perUnit: "per unit",
      unitNumberTip: "Note - the number of units will not affect the Pharmacy drug order",
      totalDrugPrice: "TOTAL DRUG PRICE"
    },
    drugs: {
      add_drug_form: {
        form: {
          drug_name: {
            search: "Type to search"
          }
        }
      }
    },
    errorMessages: {
      failed_to_get_drugs: "Failed to get drugs",
      failed_to_update_drugs_calculations: "Failed to update drugs calculations",
      failed_to_fetching_patient_data: "Failed to fetching patient data",
      filterlist_starred: "Failed to update starred status."
    },
    new_list_form: {
      cancel: "Cancel",
      save: "Save",
      update: "Update",
      save_as_new_list: "Save As New List",
      edit_list_info: "Edit List Info",
      filter_list_selected_view: "pharmacy-list",
      unsaved_details: "Unsaved Details",
      not_saved_yet:
        "You haven’t saved yet. Leaving the form will discard any unsaved changes. Are you sure you want to proceed?",
      list_name: {
        placeholder: "Choose a name to identify this list",
        title: "List Name"
      },
      description: {
        placeholder: "Enter a description...",
        title: "Description (Optional)"
      },
      list_type: {
        placeholder: "Enter a description...",
        title: "List Type",
        private: {
          title: "Private",
          description: "Only you can view and edit this list."
        },
        public: {
          title: "Public",
          description: "This list will be viewable by all users. Only you can edit."
        }
      }
    },
    saved_list_pagination: {
      saved_list_page_count: "Showing: {{range_start}}-{{range_end}} Of {{total}} Lists",
      next: "Next"
    },
    columns: {
      record_mrn: "MRN-{{mrnRecord}}",
      record_phone: "Phone: {{mrnRecord}}",
      click_to_sort_ascending: "Click to sort ascending",
      click_to_sort_descending: "Click to sort descending",
      click_to_cancel_sorting: "Click to cancel sorting"
    },
    savedList: {
      search_placeholder: "Search by list name",
      description: "From {{view}}",
      mark_as_favorite: "Mark as Favorite",
      favorites: "Favorites",
      no_records: "No Records",
      more_than_10000: "More than 10000 records",
      sort_tooltip: "Sort",
      owner_in_valid_list: "This saved list is not available due to removed filters. Please delete and recreate.",
      non_owner_in_valid_list: "This saved list is not available due to removed filters - please recreate the list.",
      list_name_private_title: "Private List",
      list_name_private_sub_title: "Only visible to you",
      list_name_public_title: "Public List",
      list_name_public_sub_title: "Visible to all members of your org",
      list_name_shared_title: "Shared List",
      list_name_shared_sub_title: "Visible to invited users",
      viewers: "Viewers",
      viewer: "Viewer",
      viewers_more: "... and {{count}} more",
      created_by: "Created by",
      copy_action: "The List link was successfully copied to your clipboard",
      copy_list_link: "Copy list link",
      saved_list_orders_page_count: "Showing: {{range_start}}-{{range_end}} Of {{total}} Orders",
      no_list_name: "List",
      title: "Saved Lists",
      last_update_lbl: "Last update: ",
      actions_menu: {
        edit: "Edit List Info",
        copy: "Copy List Link",
        export: "Export",
        delete: "Delete"
      },
      types_options: {
        all: "All",
        private: "Private",
        favorite: "Favorite",
        shared: "Shared"
      },
      confirm_modal: {
        title: "Delete List",
        content:
          "Are you sure you want to delete ‘{{listName}}’ list? No one will be able to access this list anymore.",
        cancel_text: "Cancel",
        ok_text: "Yes, Delete",
        success_message: "List was successfully deleted",
        error_message: "Could not delete list"
      },
      discard_modal: {
        title: "Unsaved Changes",
        ok_text: "Yes, Discard",
        cancel_text: "Back",
        content: "Are you sure you want to discard the changes you made?"
      }
    },
    no_saved_lists_to_show: "No Saved Lists to Show",
    no_saved_lists_found: "No lists found",
    no_favorite_description: "You don't have any favorite lists yet. Click the star icon of any list to see it here.",
    no_favorite_to_show: "No Favorite lists found.",
    no_saved_lists_to_show_description:
      "There are no saved lists in your account yet. Head to the main list view to create one.",
    no_shared_lists_to_found: "No Shared Lists Found",
    no_shared_lists_to_found_description:
      "You haven’t created or been added to any shared lists yet.\n Create a list and choose who to share it with.",
    filter_list_view: {
      filter_list_top_section: {
        saved_lists: "Saved Lists",
        details: "Details",
        description: "From {{view}} • By {{user}}",
        unsaved_changes: "You have unsaved changes",
        save: "Save",
        last_modified_lbl: "Last Modified: "
      }
    },
    edit_notes: {
      updated_by: "Last updated by: {{user}} {{updatedDate}}",
      created_by: "Created by: {{user}} {{createdDate}}",
      created_on: "Created on: {{createdDate}}",
      note_history_tooltip:
        "Created by: {{createdBy}} on {{createdDate}} \n Last updated by: {{updatedBy}} on {{updatedDate}}",
      note_history_tooltip_without_created_by:
        "Created on: {{createdDate}} \n Last updated by: {{updatedBy}} on {{updatedDate}}",
      note_created_tooltip: "Created by: {{createdBy}} on {{createdDate}}",
      note_created_tooltip_no_update: "Created on: {{createdDate}}"
    },
    export: {
      button_text: "Export",
      export_list: "Export List",
      loading_text: "Exporting",
      csv_option: "CSV",
      xlsx_option: "XLSX",
      modal_title: "Confirm Export",
      modal_summary:
        "You are about to export your current view containing <strong>{{count}}</strong> records as a <strong>{{fileType}}</strong> file.",
      modal_phi_warning_text:
        "<strong>Security Disclaimer:</strong> This file may contain Protected Health Information (PHI). By downloading, you confirm you will handle this data securely and in accordance with your organization’s policies.",
      modal_confirm_button: "Confirm",
      record_limit_exceeded_tooltip:
        "Export is limited to {{limit}} records. Please apply filters to reduce the number of records.",
      error_title: "Export Failed",
      error_message: "An error occurred while exporting. Please try again.",
      download_started: "Your download has started",
      preparing_export: "Exporting in Progress"
    }
  }
};
